import React, { useCallback, useReducer } from 'react';
import { CreateScheduleActionTypes } from '../createScheduleModalActions';
import { createScheduleReducer } from './createScheduleModalReducer';
import {
	createScheduleInitialState,
	CreateScheduleContext,
	TTypeOfCreateScheduleModalWindow,
} from './createScheduleModalContext';
import { RestaurantNotificationEventType, ICreateScheduledPush } from 'types';

const CreateScheduleState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(createScheduleReducer, createScheduleInitialState);

	const setPushType = useCallback((value: RestaurantNotificationEventType | null) => {
		dispatch({
			type: CreateScheduleActionTypes.SET_PUSH_TYPE,
			payload: {
				pushType: value,
			},
		});
	}, []);

	const changeSchedule = useCallback((value: string) => {
		dispatch({
			type: CreateScheduleActionTypes.CHANGE_SCHEDULE,
			payload: {
				schedule: value,
			},
		});
	}, []);

	const setDataForSubmit = useCallback((value: ICreateScheduledPush | null) => {
		dispatch({
			type: CreateScheduleActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfCreateScheduleModalWindow) => {
		dispatch({
			type: CreateScheduleActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	const resetFields = useCallback(() => dispatch({ type: CreateScheduleActionTypes.RESET_FIELDS }), []);

	return (
		<CreateScheduleContext.Provider
			value={{
				setPushType,
				changeSchedule,
				setDataForSubmit,
				changeTypeOfModalWindow,
				resetFields,
				pushType: state.pushType,
				schedule: state.schedule,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</CreateScheduleContext.Provider>
	);
};

export default React.memo(CreateScheduleState);
